import React from 'react';
import { Shield } from 'lucide-react';

/**
 * Logo Component - Flexible logo untuk aplikasi
 * Bisa menggunakan custom image atau fallback ke icon shield
 * 
 * Props:
 * - src: Path ke file logo (optional)
 * - alt: Alt text untuk logo (default: "SSL Monitor Logo")
 * - size: Size preset - 'sm', 'md', 'lg', 'xl' (default: 'md')
 * - className: Additional classes (optional)
 */

const sizePresets = {
  xs: {
    container: 'h-8 w-8',
    image: 'h-8 w-8',
    icon: 'h-5 w-5'
  },
  sm: {
    container: 'h-10 w-10',
    image: 'h-10 w-10',
    icon: 'h-6 w-6'
  },
  md: {
    container: 'h-12 w-12',
    image: 'h-12 w-12',
    icon: 'h-7 w-7'
  },
  lg: {
    container: 'h-16 w-16',
    image: 'h-16 w-16',
    icon: 'h-10 w-10'
  },
  xl: {
    container: 'h-20 w-20',
    image: 'h-20 w-20',
    icon: 'h-12 w-12'
  },
  '2xl': {
    container: 'h-24 w-24',
    image: 'h-24 w-24',
    icon: 'h-16 w-16'
  }
};

export function Logo({ 
  src, 
  alt = "SSL Monitor Logo", 
  size = 'md',
  className = '',
  showFallback = true 
}) {
  const [imageError, setImageError] = React.useState(false);
  const preset = sizePresets[size] || sizePresets.md;

  // Jika ada src dan belum error, tampilkan image
  if (src && !imageError) {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <img
          src={src}
          alt={alt}
          className={`${preset.image} object-contain`}
          onError={() => setImageError(true)}
        />
      </div>
    );
  }

  // Fallback ke icon shield jika tidak ada image atau error
  if (showFallback) {
    return (
      <div className={`flex items-center justify-center ${preset.container} bg-primary rounded-full ${className}`}>
        <Shield className={`${preset.icon} text-primary-foreground`} />
      </div>
    );
  }

  return null;
}

// Export size presets untuk reference
export { sizePresets };
